import { Injectable } from '@angular/core';
import { UnlinkedVeterinaryUser } from '../../domain/models/unlinked-veterinary-user.model';
import { UnlinkedVeterinaryUserDto } from '../dtos/unlinked-veterinary-user.dto';

@Injectable()
export class UnlinkedVeterinaryUserMapper {
  public toModel(dto: UnlinkedVeterinaryUserDto): UnlinkedVeterinaryUser {
    return {
      externalId: dto.ExternalId,
      email: dto.Email,
      firstName: dto.FirstName,
      lastName: dto.LastName,
      isActive: dto.IsActive,
      departmentName: dto.SedeName,
      avatarUrl: dto.AvatarUrl,
    };
  }
}
